import {
  setTabs,
  setActiveTab,
  setLoadedTab,
  setSorts,
  setLoadMore,
  setSearchType,
  setSearchTerm,
  setPopstate,
  setFilters,
  applyFilter,
  applySort,
  clearFilters,
  setFirstQuery,
} from '@/context/search/action-creators';

export default dispatch => ({
  setTabs: payload => dispatch(setTabs(payload)),
  setActiveTab: payload => dispatch(setActiveTab(payload)),
  setLoadedTab: payload => dispatch(setLoadedTab(payload)),
  setSorts: payload => dispatch(setSorts(payload)),
  setLoadMore: payload => dispatch(setLoadMore(payload)),
  setSearchType: payload => dispatch(setSearchType(payload)),
  setSearchTerm: payload => dispatch(setSearchTerm(payload)),
  setPopstate: payload => dispatch(setPopstate(payload)),
  setFilters: payload => dispatch(setFilters(payload)),
  applyFilter: payload => dispatch(applyFilter(payload)),
  applySort: payload => dispatch(applySort(payload)),
  clearFilters: () => dispatch(clearFilters()),
  setFirstQuery: payload => dispatch(setFirstQuery(payload)),
});
